<nav>
  <div class="inner-container">
    <ul class="nav">
      <ng-container *ngFor="let tabSheet of descriptor?.tabSheets">
        <li gp-menu-dropdown
            [name]="tabSheet.transId | translate"
            [dropdownActive]="tabSheet.tabSheetID === activeTabSheet?.tabSheetID">
          <ul *ngIf="tabSheet.groupZones?.length" class="nav-sub">
            <li *ngFor="let groupZone of tabSheet.groupZones"
                [class.active]="activeGroupZone === groupZone"
                (click)="selectTabSheetWithGroupZone(groupZone, tabSheet)">
              <span class="text-ellipsis p-r-2">{{groupZone.transId | translate}}</span>
            </li>
          </ul>
        </li>
      </ng-container>
    </ul>
  </div>
</nav>
